import api from './api';

const paymentService = {
  // Stripe
  createStripeIntent: (orderId) => api.post('/payments/stripe/create-intent', { orderId }),
  confirmStripePayment: (paymentIntentId) => api.post('/payments/stripe/confirm', { paymentIntentId }),

  // Razorpay
  createRazorpayOrder: (orderId) => api.post('/payments/razorpay/create-order', { orderId }),
  verifyRazorpayPayment: (data) => api.post('/payments/razorpay/verify', data),

  getPayment: (id) => api.get(`/payments/${id}`),
};

export default paymentService;
